import { Component, h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { PostType } from './Types'
import TopicRepliesEmptyStatus from './TopicRepliesEmptyStatus'
import TopicReply from './TopicReply'
import { LikedUserType } from './LikedUsers'
import Pagination from '../../control-components/ui-components/Pagination'
import qs from 'qs'
import { ContentType } from '../utils/contentType'

interface Props {
  type: ContentType
  currentUser: LikedUserType
  topicId: number
  topicAuthorId: number
  replies: PostType[]
  pinnedReplyId?: string | null
  totalRepliesPageCount: number
  currentRepliesPage: number
  totalRepliesCount: number
}

class TopicReplies extends Component<Props, {}> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }

  generateNewUrl (newPage: number) {
    const regex = /\/index\d+\.html/
    const splittedUrl = window.location.pathname.replace(regex, '')
    const newPagination = newPage === 1 ? '' : `/index${newPage}.html`
    const searchQuery = window.location.search
    const queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })
    delete queryParameters?.postid
    return `${window.location.origin}${splittedUrl}${newPagination}${qs.stringify(queryParameters) as string}`
  }

  render ({ replies, topicId, topicAuthorId, currentUser, type, pinnedReplyId, totalRepliesPageCount, currentRepliesPage, totalRepliesCount }: Props) {
    return (
      <div>
        <header className='list__items--header qa-topic-reply-box-header'>
          <h3 className='qa-total-replies'>
            <Phrase p={totalRepliesCount ? '{n} Reply|{n} Replies' : 'no.replies'} count={{ n: totalRepliesCount.toString() }} />
          </h3>
        </header>
        {
          replies.length
            ? (
              <div className='topic-reply-box-wrapper'>
                {
                  totalRepliesPageCount > 1
                    ? (
                      <Pagination totalPageCount={totalRepliesPageCount} currentPage={currentRepliesPage} generateNewUrl={this.generateNewUrl} />
                      )
                    : null
                }
                {
                  replies.map((reply: PostType, idx: number) => <TopicReply
                    key={idx}
                    currentUser={currentUser}
                    displayAuthor={reply.author.id === topicAuthorId}
                    topicId={topicId}
                    reply={reply}
                    type={type}
                    isLastItem={replies.length === idx + 1}
                    isPinned={String(reply.id) === String(pinnedReplyId)}
                                                                />)
                }
                {
                  totalRepliesPageCount > 1
                    ? (
                      <Pagination totalPageCount={totalRepliesPageCount} currentPage={currentRepliesPage} generateNewUrl={this.generateNewUrl} />
                      )
                    : null
                }
              </div>
              )
            : (
              <TopicRepliesEmptyStatus />
              )
        }
      </div>
    )
  }
}

export default TopicReplies
